import { render, staticRenderFns } from "./couponsTab.vue?vue&type=template&id=76df58ac&scoped=true&"
import script from "./couponsTab.vue?vue&type=script&lang=js&"
export * from "./couponsTab.vue?vue&type=script&lang=js&"
import style0 from "./couponsTab.vue?vue&type=style&index=0&id=76df58ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76df58ac",
  null
  
)

export default component.exports